import { FIVE9_WEBCHAT_VISITOR_TYPES } from './five9VisitorTypes';
import { PRE_PROD, getReleaseEnv } from './env';
import { getCookieObject, parseCookieValue } from './cookieUtils';

function generateHost() {
  let releaseEnvironment = getReleaseEnv();

  // use QA if in preview
  if (getReleaseEnv() === 'prod' && PRE_PROD()) {
    releaseEnvironment = 'qa';
  }

  if (releaseEnvironment) {
    return `https://contentcdn${releaseEnvironment}acct.blob.core.windows.net/online-chat`;
  } else {
    return `http://localhost:5000`;
  }
}

const genResOptions = ({ host, visitorName, mileagePlanNumber }) => ({
  title: 'Alaska Air',
  profiles: PRE_PROD() ? 'GenResQA--Chat' : 'ChatRes',
  theme: `${host}/index.css`,
  fields: {
    name: {
      value: visitorName ?? '',
      show: true,
      label: 'Name',
    },
    email: {
      value: '',
      show: false,
      label: 'Email',
    },
    'Mileage Number': {
      value: mileagePlanNumber ?? '',
      show: true,
      label: 'Mileage Plan Number',
    },
    question: {
      value: '',
      show: true,
      label: 'How can we help?',
    },
  },
});

const easyBizOptions = ({
  host,
  visitorName,
  companyName,
  mileagePlanNumber,
}) => ({
  title: 'Alaska Air EasyBiz',
  profiles: PRE_PROD() ? 'EasyBizQA--Chat' : 'ChatEasyBiz',
  theme: `${host}/index.css`,
  fields: {
    name: {
      value: visitorName ?? '',
      show: true,
      label: 'Name',
    },
    email: {
      value: '',
      show: false,
      label: 'Email',
    },
    companyName: {
      value: companyName ?? '',
      show: true,
      label: 'Company Name',
    },
    'Mileage Number': {
      value: mileagePlanNumber ?? '',
      show: true,
      label: 'Mileage Plan Number',
    },
    question: {
      value: '',
      show: true,
      label: 'How can we help?',
    },
  },
});

const travelAgentOptions = ({
  host,
  visitorName,
  travelAgentNumber,
  companyName,
}) => ({
  title: 'Alaska Air TravelAgent',
  profiles: PRE_PROD() ? 'TravelAgentQA--Chat' : 'ChatTravelAgency',
  theme: `${host}/index.css`,
  fields: {
    name: {
      value: visitorName ?? '',
      show: true,
      label: 'Name',
    },
    email: {
      value: '',
      show: false,
      label: 'Email',
    },
    iataNumber: {
      value: travelAgentNumber ?? '',
      show: true,
      label: 'IATA Number',
    },
    companyName: {
      value: companyName ?? '',
      show: true,
      label: 'Company Name',
    },
    question: {
      value: '',
      show: true,
      label: 'How can we help?',
    },
  },
});

/**
 * Returns options object prepopulated with information knwon about the user
 *
 * @param {*} visitorType type of visitor to return options for
 */
const getVisitorOptions = (visitorType) => {
  const host = generateHost();
  const ASNameCookie = getCookieObject('AS%5FNAME');
  const easyBizCookie = getCookieObject('AS%5FACNT%5FCOMPANY');
  const travelAgentCookie = getCookieObject('AS%5FPROMO%5FLOGIN');
  const firstName = parseCookieValue(ASNameCookie.FN);
  const lastName = parseCookieValue(ASNameCookie.LN);
  const visitorName = firstName + ' ' + lastName;
  const mileagePlanNumber = ASNameCookie.MP ?? '';
  let companyName; // used in easybiz and travel agent path
  let travelAgentNumber; // used by travel agent

  if (!FIVE9_WEBCHAT_VISITOR_TYPES[visitorType]) {
    visitorType = FIVE9_WEBCHAT_VISITOR_TYPES.default;
  }

  switch (visitorType) {
    case FIVE9_WEBCHAT_VISITOR_TYPES.easybiz:
      companyName = parseCookieValue(easyBizCookie.COMPANYNAME);
      return easyBizOptions({
        host,
        visitorName,
        companyName,
        mileagePlanNumber,
      });
    case FIVE9_WEBCHAT_VISITOR_TYPES.travelAgent:
      companyName = parseCookieValue(easyBizCookie.COMPANYNAME);
      travelAgentNumber = travelAgentCookie.TANUMBER ?? '';
      return travelAgentOptions({
        host,
        visitorName,
        travelAgentNumber,
        companyName,
      });
    case FIVE9_WEBCHAT_VISITOR_TYPES.default:
    default:
      return genResOptions({ host, visitorName, mileagePlanNumber });
  }
};

export default getVisitorOptions;
